export default "__VITE_ASSET__wpH7NcF8__"